import { useIsLoggedOn } from "../../stores/hooks/useIsLoggedOn";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";

export const usePricingAnalysisSetting = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  const isLoggedOn = useIsLoggedOn();

  const setting = dealer?.dealerEnablePricingAnalysis || "HIDE";

  if (setting === "SHOW") {
    return true;
  }

  if (isLoggedOn) {
    return setting === "AUTH";
  }

  return false;
};
